import React, { useState, useRef } from "react";
import { useAuth } from "../../firebase/authContext";
import { useRecoilValue } from "recoil";
import { userTypeState } from "../../Recoil/atoms";

const UploadVideoPopUp = ({ showPopUp, onClose }) => {
  const { currentUser } = useAuth(); // Get current logged-in user
  const userType = useRecoilValue(userTypeState); // Get user type from recoil state

  const [video, setVideo] = useState(null);
  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [uploading, setUploading] = useState(false);

  // Add sessionId ref
  const sessionIdRef = useRef(crypto.randomUUID());

  // Add a computed variable to check if all required fields are filled
  const isFormValid =
    video && title.trim() && description.trim() && tags.trim();

  if (!showPopUp) return null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setVideo(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!video) {
      alert("Please select a video file.");
      return;
    }

    setUploading(true);

    const formData = new FormData();
    formData.append("video", video);
    formData.append("title", title);
    formData.append("uploaded_by", currentUser.uid); // Correctly using UID from Firebase Auth
    formData.append("username", currentUser.displayName);
    formData.append("description", description);
    formData.append("tags", tags);

    if (userType === "coaching_center") {
      formData.append("category", category);
    }

    console.log(
      "The values are",
      title,
      currentUser.uid,
      description,
      tags,
      userType
    );

    try {
      const response = await fetch(
        "https://dance-ai-app.azurewebsites.net/api/upload_video",
        {
          method: "POST",
          headers: {
            "X-Session-ID": sessionIdRef.current,
          },
          body: formData,
        }
      );

      const result = await response.json();
      if (response.ok) {
        alert("✅ Video uploaded successfully!");
        onClose();
      } else {
        alert(`❌ Error: ${result.error}`);
      }
    } catch (error) {
      console.error("Upload Error:", error);
      alert("❌ Video upload failed.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-96 relative">
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
          onClick={onClose}
        >
          ✖
        </button>
        <h2 className="text-xl font-bold mb-4">Upload a Video</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="file"
            accept="video/*"
            onChange={handleFileChange}
            required
          />

          <input
            type="text"
            placeholder="Caption"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />

          <textarea
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />

          <input
            type="text"
            placeholder="Tags (comma separated)"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            className="w-full border p-2 rounded"
            required
          />

          {userType === "coaching_center" && (
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="w-full border p-2 rounded"
              required
            >
              <option value="">Select Video Type</option>
              <option value="playlist">Playlist</option>
              <option value="class">Class</option>
              <option value="program">Program</option>
              <option value="normal">Normal Video</option>
            </select>
          )}

          <button
            type="submit"
            className={`w-full bg-indigo-500 text-white py-2 rounded-lg ${
              !isFormValid || uploading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={!isFormValid || uploading}
          >
            {uploading ? "Uploading..." : "Upload Video"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadVideoPopUp;
